module.exports = __webpack_public_path__ + "img/ac11.b17af5bf.jpg";